var map = {
	"./tip-error.png": "CsmL",
	"./tip-info.png": "vAHV",
	"./tip-success.png": "pwmz",
	"./tip-warning.png": "E3xd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HauX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/tip\-.*\.png$
// module id = HauX
// module chunks = 1